var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_delivery"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33333 22.1667C9.95217 22.1667 10.5457 21.9208 10.9832 21.4832C11.4208 21.0457 11.6667 20.4522 11.6667 19.8333C11.6667 19.2145 11.4208 18.621 10.9832 18.1834C10.5457 17.7458 9.95217 17.5 9.33333 17.5C8.71449 17.5 8.121 17.7458 7.68342 18.1834C7.24583 18.621 7 19.2145 7 19.8333C7 20.4522 7.24583 21.0457 7.68342 21.4832C8.121 21.9208 8.71449 22.1667 9.33333 22.1667V22.1667ZM21 22.1667C21.6188 22.1667 22.2123 21.9208 22.6499 21.4832C23.0875 21.0457 23.3333 20.4522 23.3333 19.8333C23.3333 19.2145 23.0875 18.621 22.6499 18.1834C22.2123 17.7458 21.6188 17.5 21 17.5C20.3812 17.5 19.7877 17.7458 19.3501 18.1834C18.9125 18.621 18.6667 19.2145 18.6667 19.8333C18.6667 20.4522 18.9125 21.0457 19.3501 21.4832C19.7877 21.9208 20.3812 22.1667 21 22.1667V22.1667Z",
    stroke: "#0076BE",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7253 19.8333H17.5003V7.7C17.5003 7.51435 17.4266 7.3363 17.2953 7.20503C17.164 7.07375 16.986 7 16.8003 7H1.16699M6.59199 19.8333H4.20033C4.1084 19.8333 4.01737 19.8152 3.93245 19.78C3.84752 19.7449 3.77035 19.6933 3.70535 19.6283C3.64035 19.5633 3.58879 19.4861 3.55361 19.4012C3.51843 19.3163 3.50033 19.2253 3.50033 19.1333V13.4167",
    stroke: "#0076BE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.33398 10.5H7.00065",
    stroke: "#0076BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.5 10.5H24.045C24.1803 10.5 24.3127 10.5393 24.4262 10.613C24.5396 10.6867 24.6293 10.7917 24.6843 10.9153L26.7727 15.6147C26.8124 15.7039 26.8331 15.8005 26.8333 15.8982V19.1333C26.8333 19.2253 26.8152 19.3163 26.78 19.4012C26.7449 19.4861 26.6933 19.5633 26.6283 19.6283C26.5633 19.6933 26.4861 19.7449 26.4012 19.78C26.3163 19.8152 26.2253 19.8333 26.1333 19.8333H23.9167M17.5 19.8333H18.6667",
    stroke: "#0076BE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.f2ab4a66c2ed42e897d0443e82613b72.svg";
export { ForwardRef as ReactComponent };